import { FC } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { ArrowLeft } from 'lucide-react';

import { Menu } from '@/components/Layouts/Menu';
import { InstagramIcon, MercadoPagoIcon } from '@/components/Icons';
import { AppSidebar } from '@/components/Sidebar/Sidebar';
import LogoSvg from '/logo.svg';
import { Toaster } from '@/components/ui/sonner';
import { RouteTransition } from '@/components/RoutesTransition/RoutesTransition';
import { ScrollToTop } from '@/components/RoutesTransition/ScrollToTop';
import { VersionToast } from '@/components/VersionToast/VersionToast';

import pkg from '../../../package.json';

export const BaseLayout: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  console.log(`Version: ${pkg.version}`);

  return (
    <>
      <ScrollToTop />
      <Toaster duration={2500} />
      <VersionToast />
      <div
        className="relative flex min-h-screen flex-col overflow-x-hidden pb-10 pt-4 text-left"
        style={{ background: 'var(--nb-bg)' }}
      >
        <AppSidebar />

        {/* Top bar: logo left, menu right */}
        <header
          className="sticky top-0 z-30 flex items-center justify-between gap-2 px-3 py-2 sm:px-4"
          style={{ background: 'var(--nb-bg)' }}
        >
          <div className="flex min-w-0 flex-1 items-center gap-2">
            {pathname !== '/' && (
              <button
                onClick={() => navigate(-1)}
                aria-label="Volver"
                className="nb-btn nb-btn-sm fill-paper shrink-0"
                style={{ padding: '4px 8px' }}
              >
                <ArrowLeft size={14} />
              </button>
            )}
            <button
              onClick={() => navigate('/')}
              aria-label="Ir al inicio"
              className="flex h-14 w-14 shrink-0 items-center justify-center sm:h-16 sm:w-16"
            >
              <img src={LogoSvg} alt="Rescatapp" className="h-full w-full object-contain" />
            </button>
          </div>
          <Menu />
        </header>

        <main className="mt-3">
          <RouteTransition />
        </main>

        <footer className="mt-10 px-4">
          <div className="nb-thick-rule" />
          <div
            className="flex flex-wrap items-center gap-x-3 gap-y-2 py-3 text-[11px] font-bold uppercase tracking-[0.08em]"
            style={{ fontFamily: '"JetBrains Mono", monospace' }}
          >
            <span onClick={() => navigate('/us')} className="cursor-pointer">
              NOSOTROS
            </span>
            <span>·</span>
            <span onClick={() => navigate('/mision')} className="cursor-pointer">
              MISIÓN
            </span>
            <span>·</span>
            <span onClick={() => navigate('/faq')} className="cursor-pointer">
              FAQ
            </span>
            <span>·</span>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSdheWXSRR_bIABYl1guAFpgqFw1VdFljXTtOxs0Gnhhkqauag/viewform?usp=publish-editor"
              target="_blank"
              rel="noopener noreferrer"
            >
              FEEDBACK
            </a>
          </div>
          <div className="nb-hairline" />

          <div
            className="flex flex-wrap items-center gap-4 py-3 text-[12px] font-bold"
            style={{ fontFamily: '"JetBrains Mono", monospace' }}
          >
            <a
              className="flex items-center gap-2"
              href="https://www.instagram.com/rescatapp.ok/"
              target="_blank"
              rel="noopener noreferrer"
            >
              SEGUINOS EN <InstagramIcon />
            </a>
            <a
              className="flex items-center gap-2"
              href="https://link.mercadopago.com.ar/rescatapp"
              target="_blank"
              rel="noopener noreferrer"
            >
              DONACIONES <MercadoPagoIcon />
            </a>
          </div>

          <div className="nb-hairline" />

          <div
            className="space-y-1 py-3 text-[10px] opacity-70"
            style={{ fontFamily: '"JetBrains Mono", monospace' }}
          >
            <p>RESCATAPP · ARGENTINA · © 2026 · SIN FINES DE LUCRO</p>
            <p>
              <span onClick={() => navigate('/tyc')} className="cursor-pointer font-bold">
                TÉRMINOS Y CONDICIONES
              </span>{' '}
              ·{' '}
              <span
                onClick={() => navigate('/privacy-policy')}
                className="cursor-pointer font-bold"
              >
                PRIVACIDAD
              </span>
            </p>
            <p>
              CONTACTO ·{' '}
              <a href="mailto:contacto@rescatapp.com.ar" className="cursor-pointer font-bold">
                contacto@rescatapp.com.ar
              </a>
            </p>
          </div>
        </footer>
      </div>
    </>
  );
};
